import { createContext } from "react";

import { IBalancesContext } from "../interfaces-and-types";

export const BalancesContext = createContext<IBalancesContext>({
  // active balance
  activeBalanceCurrency: null,
  setActiveBalanceCurrency: () => {},

  // remote data
  isSuccess: false,
  isError: false,
  isLoading: false,
  data: [],
  refreshRemoteData: () => {},
});
